import styled from 'styled-components';

import { Link } from 'components/RouterLink';
import { fontWeights } from 'theme';

export const StyledLink = styled(Link)`
  font-weight: ${fontWeights.semiBold};
`;
